import { NgModule } from '@angular/core';
import { CommonModule, Location,PathLocationStrategy,LocationStrategy,HashLocationStrategy} from "@angular/common";
import { RouterModule, Routes } from '@angular/router';
import { PersonalLoanOffersComponent } from "app/loan/personal-loan-offers/personal-loan-offers.component";
import { OwlModule } from "ng2-owl-carousel";
import { SharedModule } from "app/shared/shared.module";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { LoanOfferGenService } from "app/loan/services/loan-offer-gen.service";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";

import { NgSelectorModule } from 'ng-selector';
import { HomeLoanPageResolver } from "app/loan/home-loan-page/home-loan-page-resolve";
import { PersonalLoanTransferPageResolver } from "app/loan/personal-loan-transfer-page/personal-loan-transfer-page-resolve";
import { HomeLoanTransferPageResolver } from "app/loan/home-loan-transfer-page/home-loan-transfer-page-resolve";
import { PersonalLoanPageResolver } from "app/loan/personal-loan-page/personal-loan-page-resolve";
import { LoanRoutingModule } from "app/loan/loan-routing.module";
import { HomeLoanOffersComponent } from "app/loan/home-loan-offers/home-loan-offers.component";
import { HlProductPopupTableComponent } from "app/loan/lead-popup-product-info/hl-product-popup-table/hl-product-popup-table.component";
import { PlProductPopupTableComponent } from "app/loan/lead-popup-product-info/pl-product-popup-table/pl-product-popup-table.component";
import { HomeLoanPageComponent } from "app/loan/home-loan-page/home-loan-page.component";
import { PersonalLoanPageComponent } from "app/loan/personal-loan-page/personal-loan-page.component";
import { HlFormComponent } from "app/loan/hl-form/hl-form.component";
import { HomeLoanTransferPageComponent } from "app/loan/home-loan-transfer-page/home-loan-transfer-page.component";
import { PersonalLoanTransferPageComponent } from "app/loan/personal-loan-transfer-page/personal-loan-transfer-page.component";
import { PlFormComponent } from "app/loan/pl-form/pl-form.component";
import { CompanyOffersModule } from "app/company-offers/company-offers.module";
import { ApplyLoanModelPopupComponent } from "app/loan/apply-loan-model-popup/apply-loan-model-popup.component";
import { LoanApplyFormComponent } from "app/loan/loan-apply-form/loan-apply-form.component";
import { CsPersoanlLoanFormComponent } from "app/company-offers/cs-persoanl-loan-form/cs-persoanl-loan-form.component";
import { CsHomeLoanFormComponent } from "app/company-offers/cs-home-loan-form/cs-home-loan-form.component";
import { DefaultProductPopupTableComponent } from "app/loan/default-product-popup-table/default-product-popup-table.component";
import { NKDatetimeModule } from "ng2-datetime/ng2-datetime";
import { HomeLoanMainComponent } from './home-loan-main/home-loan-main.component';
import { PersonalLoanMainComponent } from './personal-loan-main/personal-loan-main.component';
import { HomeLoanTaxSavingsComponent } from './home-loan-tax-savings/home-loan-tax-savings.component';


@NgModule({
  imports: [
    CommonModule,
    OwlModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    NgbModule,
    NgSelectorModule,
    NKDatetimeModule,
    LoanRoutingModule,

    
  ],
  declarations: [
    PersonalLoanOffersComponent,
    HomeLoanOffersComponent,
    HlProductPopupTableComponent,
    PlProductPopupTableComponent,
    HomeLoanPageComponent,
    PersonalLoanPageComponent,
    HlFormComponent,
    PlFormComponent,
    HomeLoanTransferPageComponent,
    PersonalLoanTransferPageComponent,
    ApplyLoanModelPopupComponent,
    LoanApplyFormComponent,
    CsPersoanlLoanFormComponent,
    CsHomeLoanFormComponent,
    DefaultProductPopupTableComponent,
    HomeLoanMainComponent,
    PersonalLoanMainComponent,
    HomeLoanTaxSavingsComponent 
    
 


  ],
  exports:[
    PersonalLoanOffersComponent,
    HomeLoanOffersComponent,
    HlProductPopupTableComponent,
    PlProductPopupTableComponent,
    // HomeLoanPageComponent,
    // HomeLoanTransferPageComponent,
    // PersonalLoanTransferPageComponent,
    // HomeLoanTaxSavingsComponent,
    // PersonalLoanPageComponent,
    ApplyLoanModelPopupComponent,
    LoanApplyFormComponent,
    CsPersoanlLoanFormComponent,
    CsHomeLoanFormComponent,
    DefaultProductPopupTableComponent,
    HlFormComponent 
      
  ],
  providers:[
    LoanOfferGenService,
    HomeLoanPageResolver,
    PersonalLoanTransferPageResolver,
    HomeLoanTransferPageResolver,
    PersonalLoanPageResolver,
  ],
  entryComponents: [ApplyLoanModelPopupComponent],
})
export class LoanOffersModule { }



// WEBPACK FOOTER //
// ./src/app/loan/loan-module.module.ts